import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { CTAButton } from "./UI";

export default function Hero() {
  const [play, setPlay] = useState(false);
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    const t = setTimeout(() => setPlay(true), 80);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (!play) return;
    const t = setTimeout(() => {
      const interval = setInterval(() => {
        setCounter((c) => {
          if (c >= 100) { clearInterval(interval); return 100; }
          return c + 2;
        });
      }, 18);
      return () => clearInterval(interval);
    }, 1200);
    return () => clearTimeout(t);
  }, [play]);

  return (
    <section id="hero" className={"hero" + (play ? " play" : "")}>

      {/* ── Grain overlay ── */}
      <div className="hero-grain" aria-hidden="true" />

      {/* ── Vertical rule lines ── */}
      <div className="hero-vlines" aria-hidden="true">
        <span /><span /><span /><span /><span />
      </div>

      {/* ── Animated floating orbs ── */}
      <div className="hero-orb hero-orb-1" aria-hidden="true" />
      <div className="hero-orb hero-orb-2" aria-hidden="true" />
      <div className="hero-orb hero-orb-3" aria-hidden="true" />

      {/* ── Gold glow blobs ── */}
      <div className="hero-glow hero-glow-1" aria-hidden="true" />
      <div className="hero-glow hero-glow-2" aria-hidden="true" />

      {/* ── Top meta bar ── */}
      <div className="hero-topbar">
        <div className="container hero-topbar-inner">
          <span className="hero-topbar-label">
            <span className="hero-topbar-dot" />
            Brand · Digital · Growth
          </span>
          <span className="hero-topbar-year">Est. 2026</span>
        </div>
      </div>

      {/* ── Main content ── */}
      <div className="container hero-main">

        {/* Left side — stat + descriptor */}
        <div className="hero-left-col">
          <div className="hero-big-num">
            <span className="hero-big-num-val">{Math.min(counter, 100)}</span>
            <span className="hero-big-num-plus">%</span>
          </div>
          <p className="hero-big-num-label">Client<br />Focus</p>
          <div className="hero-left-divider" />
          <p className="hero-left-tagline">
            Strategy.<br />Creative.<br />Technology.
          </p>
        </div>

        {/* Center — headline */}
        <div className="hero-center-col">
          <div className="hero-eyebrow">
            <span className="hero-eyebrow-dot" />
            OVARD DIGITAL
          </div>
          <div className="hero-center-rule" aria-hidden="true" />
          {/*
            H1 is visually split into animated lines but semantically reads as one heading.
            The aria-label provides the complete, SEO-meaningful string to screen readers
            and search engines that parse accessible names.
          */}
          <h1 aria-label="OVARD Digital — Digital Marketing and Brand Growth Agency">
            <span className="line"><span>Your</span></span>
            <span className="line hero-indent"><span>Brand.</span></span>
            <span className="line hero-indent-2"><span>Our</span></span>
            <span className="line"><span>Strategy.</span></span>
            <span className="line hero-gold-line hero-shimmer-line"><span>Unlimited</span></span>
            <span className="line hero-gold-line hero-indent"><span>Growth.</span></span>
          </h1>
        </div>

        {/* Right side — sub copy + CTAs */}
        <div className="hero-right-col">
          <p className="hero-sub">
            We build the digital presence, creative and marketing systems that help businesses move forward.
          </p>
          <div className="hero-ctas">
            <CTAButton solid href="#contact">Start a conversation</CTAButton>
            <Link to="/services" className="link-inline">
              Explore Services <span className="arr">↓</span>
            </Link>
          </div>
          <div className="hero-services-list">
            {["Brand Identity", "Digital Presence", "Content & Creative", "Performance Growth", "Smart Systems"].map((s, i) => (
              <div className="hero-service-item" key={s} style={{ transitionDelay: `${1.1 + i * 0.08}s` }}>
                <span className="hero-service-num">0{i + 1}</span>
                <span>{s}</span>
              </div>
            ))}
          </div>
        </div>

      </div>

      {/* ── Bottom strip ── */}
      <div className="hero-strip">
        <div className="container hero-strip-inner">
          <div className="hero-tags">
            {["BRAND", "DIGITAL", "CONTENT", "GROWTH"].map((t, i, a) => (
              <React.Fragment key={t}>
                <span className="hero-tag">{t}</span>
                {i < a.length - 1 && <span className="hero-tag-sep" aria-hidden="true">·</span>}
              </React.Fragment>
            ))}
          </div>
          <div className="hero-scroll-hint">
            <span>Scroll</span>
            <span className="hero-scroll-line" />
          </div>
        </div>
      </div>

    </section>
  );
}
